import { createContext, useContext } from "react";

// Optional service injection: the original research demo remains standalone.
export const DemoContext = createContext(null);
export const useDemoServices = () => useContext(DemoContext);
